export default "__VITE_ASSET__C_DuN_$4__"